import * as React from 'react'
import moment from 'moment'

interface AuditProps {
  auditTrail: Array<{
    id: string
    createdAt: string
    updatedBy: string
    prevData: string
    currentData: string
    column?: number
  }>
  timeFormat: string
}

class Audit extends React.Component<AuditProps> {
  public render() {
    return (
      <div style={{ width: '600px' }}>
        <div className='flex col-12 mt1'>
          <span className='col-4 font-dark-grey h6 weight-500'>
            <b>Modified by</b>
          </span>
          <span className='col-4 font-dark-grey h6 weight-500'>
            <b>Previous Data</b>
          </span>
          <span className='col-4 font-dark-grey h6 weight-500'>
            <b>New Data</b>
          </span>
          <span className='col-4 font-dark-grey h6 weight-500'>
            <b>Updated at</b>
          </span>
        </div>
        {this.props.auditTrail.map(item => {
          return (
            <div className='flex col-12 mt1' key={item.id}>
              <span className='col-4 font-dark-grey h6 weight-500 text-wrap-balance'>{item.updatedBy}</span>
              <span className='col-4 font-dark-grey h6 weight-500 text-wrap-balance'>
                {this.formatData(item.prevData, item.column)}
              </span>
              <span className='col-4 font-dark-grey h6 weight-500 text-wrap-balance'>
                {this.formatData(item.currentData, item.column)}
              </span>
              <span className='col-4 font-dark-grey h6 weight-500'>{this.formatData(item.createdAt)}</span>
            </div>
          )
        })}
        {this.props.auditTrail.length === 0 && (
          <div className='flex col-12 mt1 font-dark-grey h6 weight-500 justify-center'>
            No Audit Trail Data Available.
          </div>
        )}
      </div>
    )
  }
  private formatData(item: string, column?: number): any {
    const timeFormat = this.props.timeFormat === 'mil' ? 'M/D/YYYY HH:mm' : 'M/D/YYYY hh:mmA'

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })

    if (this.checkIfDate(item)) {
      return moment(item).format(timeFormat)
    }

    if (column === 8) {
      const parsedJson: any[] = JSON.parse(item)
      console.log(parsedJson)

      return parsedJson.map((json: any, index) => {
        return (
          <div key={index} style={{ ...(parsedJson.length > 1 && { paddingBottom: '8px' }) }}>
            <div>Rider Type: {json.riderType}</div>
            <div>Fare Type: {json.fareType}</div>
            <div>Total Riders: {json.totalRider}</div>
            <div>Collected: {formatter.format(json.amount)}</div>
          </div>
        )
      })
    }
    return item
  }
  private checkIfDate(item: string) {
    const regex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/
    return item.match(regex)
  }
}

export default Audit



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/Audit.tsx